<template>
  <article v-if="html">
    <div id="article" class="pd70">
      <div class="wrapper w1100">
        <div class="article article_text" :class="{ of }">
          <UiAnim ref="el">
            <HtmlContent :html="html" />
          </UiAnim>
        </div>
        <UiAnim
          tag="button"
          class="article_read_more"
          v-if="of"
          @click="showHtml"
          >Читать далее
          <IconNewsPaper />
        </UiAnim>
      </div>
    </div>
  </article>
  <ModalArticleFull :html="html" v-if="show" @closed="show = false" />
</template>

<script setup>
import { useElementSize } from "@vueuse/core";
import { useTemplateRef } from "vue";
const { isModal } = useModal();

const props = defineProps(["html", "name"]);
const el = useTemplateRef("el");
const { height } = useElementSize(el);
const of = ref();
const show = ref();

watch(height, (h) => {
  if (h > 300) of.value = true;
  else of.value = false;
});

const showHtml = () => {
  if (props.name && !isModal)
    return navigateTo({ path: "/_modal", query: { text: props.name } });
  show.value = true;
};
</script>
